import React, { useContext, useEffect, useMemo, useState } from "react";
import Box from "@material-ui/core/Box";
import { DataGrid } from "@mui/x-data-grid";
import Checkbox from "@material-ui/core/Checkbox";
import ActionButton, { getCurrentGroupOrder } from "./ActionButton";
import TransferDialog from "./TransferDialog";
import { ApplicationDataAPI } from "../API/ApplicationDataAPI";
import { DocsDataAPI } from "../API/DocsDataAPI";
import useAPIError from '../APIError';
import ApplicationContext from "./ApplicationContext";
import MoveDialog from "./MoveDialog";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import Tooltip from "@material-ui/core/Tooltip";

const SELECT_ALL = "Select All";
const TRUE = "True";

const getFourLetters = (name) => {
	if (!name) return "";
	return name.substring(0, 5).toUpperCase();
};

const getTRPvalue = (data) => {
	return getFourLetters(data);
};

const getWrappedCharacters = (str) => {
	if (!str) return "";
	return str.length > 12 ? str.substring(0, 12) + "..." : str;
};

const AppTable = ({
	data,
	renderAllRows,
	isAdminConsole,
	onAppOpen,
	pageHeight,
	setIsRefresh
}) => {
	const { addError, setLoader } = useAPIError();
	const [transferOpen, setTransferOpen] = useState(false);
	const [transferPerson, setTransferPerson] = useState({});
	const [transferOptions, setTransferOptions] = useState([]);
	const [moveDMOpen, setMoveDMOpen] = useState(false);
	const [moveStatus, setMoveStatus] = useState("");
	const [moveNote, setMoveNote] = useState("");
	const [curAppData, setCurAppData] = useState({});
	const { onAppSelected } = useContext(ApplicationContext);

	const dealTypeToolTip =
		"First character represents Deal Type:(S)Silver, (G)Gold, (P)Platinum, Second character represents Deal Setup: (C)Cash out, (F)Franchise, (M)Medical, (PP)Private Party, (T)Trade-In, (S)Standard";
	const materialData = useMemo(() => {
		const sortedData = data.slice().sort((rowA, rowB) => {
			return rowB.sort_order_hours_in_queue - rowA.sort_order_hours_in_queue
		});
		return sortedData;
	}, [data]);

	const handleTransferOpen = (bool, app) => {
		setTransferOpen(bool);
		setCurAppData(app);
	};
	const handleMoveOpen = (bool, app) => {
		setMoveDMOpen(bool);
		setCurAppData(app);
	};
	const renderCustomCell = (rowData) => {
		const isUser =
			rowData?.locked_by_email?.toLowerCase() ===
				window?.authProvider?.account?.userName?.toLowerCase()
				? true
				: false;

		let backColor = "";

		if (isAdminConsole) {
			backColor = "#cd0200";
		} else if (rowData.is_locked && !isUser) {
			backColor = "#cd0200";
		} else if (rowData.is_locked && isUser) {
			backColor = "#3cb521";
		} else {
			backColor = "#6eaed4";
		}
		return {
			textAlign: "center",
			backgroundColor: backColor,
			width: "100%",
			height: "100%",
			display: "flex",
			justifyContent: "center",
			flexDirection: "column"
		};
	};

	const moveToDM = async (app) => {
		let latestDealStructure = "";
		let err = "";
		setLoader(true);
		await DocsDataAPI.fetchApplicationDealsById(app.id, app.broker_id, app.locked_by_email)
			.then((resp) => {
				for (let i = 0; i < resp.length; i++) {
					if (resp[i].selected_for_submitted_deal == true) {
						latestDealStructure = resp[i];
						break;
					}
				}
			})
			.catch((error) => {
				err = error;
				console.log("error", error);
				addError(error.message)
			});

		if (!err)
			await DocsDataAPI.moveToDmApplication(app?.broker_id, app?.locked_by_email, {
				id: app?.id,
				broker_id: app?.broker_id,
				status: "Dealmaker",
				is_locked:false,
				selected_for_proposal:false,
				selected_for_submitted_deal:false,
				disable_lock:true,
			})
				.catch((error) => {
					err = error.statusMessage;
					console.log("error", error);
					addError(error.statusMessage);
				});

		if (!err)
			await DocsDataAPI.moveToDmCreditAnalysis(app?.broker_id, app?.locked_by_email, {
				application_id: app?.id,
				id: latestDealStructure?.credit_analysis_id,
				is_locked: false,
			}).catch((error) => {
				err = error.statusMessage;
				console.log("error", error);
				addError(error.statusMessage)
			});

		if (!err)
			await DocsDataAPI.moveToDmDealStructure(app?.broker_id, app?.locked_by_email, {
				application_id: app?.id,
				id: latestDealStructure?.id,
				credit_analysis_id: latestDealStructure?.credit_analysis_id,
				selected_for_submitted_deal: false,
				disable_lock: true,
				is_locked:false,
                selected_for_proposal:false,
			}).catch((error) => {
				err = error.statusMessage;
				console.log("error", error);
				addError(error.statusMessage)
			});
		setLoader(false);
		setIsRefresh(true);
	};

	const moveAppToQueue = async (app) => {
		let moveSubject = "";
		if (app?.status == "Credit Review" || app?.status == "Credit Adjudication") {
			moveSubject = "Move Application to Asset Review";
			let moveAppObj = {
				id: app?.id,
				broker_id: app?.broker_id,
				move_note: moveNote,
				move_status: moveStatus,
				move_subject: moveSubject,
			};
			await ApplicationDataAPI.moveAppToAssetReview(moveAppObj, app?.broker_id, app?.locked_by_email);
			setIsRefresh(true);
		} else {
			moveSubject = "Move Application to Dealmaker";
			moveToDM(app);
		}
		onAppSelected("refresh", {});
	};

	const transferDeal = async (app) => {
		let transferAppObj = {
			id: app?.id,
			broker_id: app?.broker_id,
			selected_user_id: transferPerson?.id,
			groupid_code: 'GRP' + getCurrentGroupOrder(app.status)// transferPerson.details?.Group_Id__c,
		};
		await ApplicationDataAPI.transferDeal(transferAppObj, app?.broker_id, app.locked_by_email);
		setIsRefresh && setIsRefresh(true);
		onAppSelected("refresh", {});
	};
	const [sortModel, setSortModel] = React.useState([

	]);
	useEffect(() => {
		const model = localStorage.getItem('model');
		if (model) 
		setSortModel(JSON.parse(model));
	}, []);
	const handleSortModel = (model) => {
		setSortModel(model);
		localStorage.setItem("model", JSON.stringify(model)
		);
	}
	// FAS-8061: persist user column show/hide so the FAS-7510 background poll
	// (which recreates the columns prop on every refresh) can't reset it.
	const [columnVisOverrides, setColumnVisOverrides] = useState({});
	useEffect(() => {
		const saved = localStorage.getItem("queueColumnVisibility");
		if (saved) setColumnVisOverrides(JSON.parse(saved));
	}, []);
	const primaryColumn = [
		{
			headerName: "App ID",
			field: "id",
			minWidth: 100,
			flex: 0.5,
			filtering: true,
			align: "center",
			defaultFilter: "",
			headerAlign: 'center',
		},
		{
			headerName: "Amt",
			field: "invoice_amount",
			headerAlign: 'center',
			filtering: true,
			flex: 0.6,
			type: "number",
			align: "center",
			customFilterAndSearch: (term, rowData) => {
				if (term.toString().includes("<") || term.toString().includes(">")) {
					const comparisionOperator = term.toString().substring(0, 1);
					const actualValue = term.trim().slice(1);

					if (comparisionOperator === "<") {
						return Number(rowData?.invoice_amount) < Number(actualValue);
					} else if (comparisionOperator === ">") {
						return Number(rowData?.invoice_amount) > Number(actualValue);
					}
				}

				return term === rowData?.invoice_amount?.toString();
			},
			renderCell: (rowData) => (
				<>
					{Math.round(rowData?.row?.invoice_amount)?.toLocaleString("en-US", {
						maximumFractionDigits: 0,
					})}
				</>
			),
			defaultFilter: "",
			hide: !renderAllRows
		},
		{
			headerName: "RFI",
			field: "on_hold",
			align: "center",
			headerAlign: 'center',
			filtering: true,
			type: 'boolean',
			flex: 0.4,
			renderCell: (rowData) => <Checkbox disabled checked={rowData?.row?.on_hold} />,
			defaultFilter: "",
			hide: !renderAllRows
		},
		{
			headerName: "Deal Type",
			renderHeader: () => (
				<>
					<Tooltip title={dealTypeToolTip}>
						<InfoOutlined
							style={{ cursor: "pointer", fontSize: "17px" }}
						></InfoOutlined>
					</Tooltip>
					{' Deal Type'}
				</>
			),
			sortable: false,
			field: "deal_type-deal_setup",
			headerAlign: 'center',
			filtering: true,
			align: "left",
			maxWidth: 70,
			hide: (document.title.includes("DOCUMENT") ||
				document.title.includes("FUNDING") || document.title.includes("DEAL REVIEW")
			) && renderAllRows
				? false
				: true,
			valueGetter: (rowData) =>
				`${rowData?.row?.deal_type || ''}-${rowData?.row?.deal_setup || ''}`,

		},
		{
			headerName: "Name",
			field: "applicant_name",
			headerAlign: 'center',
			filtering: true,
			flex: 1,
			align: "left",
			render: (rowData) => <>{getWrappedCharacters(rowData?.applicant_name)}</>,
			hide: !renderAllRows
		},
		{
			headerName: "TPR",
			// TODO: just first four chars. (ALL caps)
			field: "broker_short_name",
			headerAlign: 'center',
			align: "center",
			filtering: true,
			flex: 0.5,
			render: (rowData) => <>{getTRPvalue(rowData?.broker_short_name)}</>,
			hide: !renderAllRows
		},
		{
			headerName: "AM",
			// TODO: The first letters of the first two words in caps.
			field: "account_manager_id",
			headerAlign: 'center',
			align: "center",
			minWidth: 30,
			flex: 0.65,
			filtering: true,
			hide: (document.title === "APP REVIEW" ||
				document.title === "ASSET REVIEW" ||
				document.title === "PRE-CREDIT REVIEW" ||
				document.title === "CREDIT REVIEW" ||
				document.title === "CREDIT ADJUDICATION"
			) ? true : !renderAllRows,
			// render: (rowData) => <>{getAbbrName(rowData?.account_manager_id)}</>,
		},
		{
			headerName: "Internal",
			field: "portalSource",
			align: "center",
			type: 'boolean',
			headerAlign: 'center',
			filtering: true,
			flex: 0.5,
			minWidth: 30,
			renderCell: (rowData) => {
				return <Checkbox disabled checked={rowData?.row?.portalSource} />;
			},
			customFilterAndSearch: (term, rowData) => {
				if (term === SELECT_ALL) return true;
				const portalSource = rowData?.app_portal_source;
				const internal =
					portalSource === "FASTT" ||
					portalSource === "SFDC" ||
					portalSource === "HD";
				if (TRUE === term) {
					return internal;
				} else {
					return !internal;
				}
			},
			hide: (document.title === "APP REVIEW" ||
				document.title === "ASSET REVIEW" ||
				document.title === "PRE-CREDIT REVIEW" ||
				document.title === "CREDIT REVIEW" ||
				document.title === "CREDIT ADJUDICATION"
			) ? true : !renderAllRows,
		},
		{
			headerName: "Org",
			field: "record_type",
			align: "center",
			headerAlign: 'center',
			filtering: true,
			flex: 0.5,
			minWidth: 50,
			customFilterAndSearch: (term, rowData) => {
				if (term === SELECT_ALL) return true;
				return rowData?.record_type?.toString() === term;
			},
			hide: !renderAllRows
		},
		{
			headerName: "Resubmit Count",
			field: "resubmit_count",
			headerAlign: 'center',
			filtering: true,
			type: "number",
			align: "center",
			minWidth: 30,
			flex: 0.5,
			customFilterAndSearch: (term, rowData) => {
				return term === rowData?.recalled_count?.toString();
			},
			hide: (document.title === "APP REVIEW" ||
				document.title === "ASSET REVIEW" ||
				document.title === "PRE-CREDIT REVIEW" ||
				document.title === "CREDIT REVIEW" ||
				document.title === "CREDIT ADJUDICATION"
			) ? true : !renderAllRows,
		},
		{
			headerName: "Status",
			field: "status",
			headerAlign: 'center',
			filtering: true,
			align: "left",
			hide: (document.title === "DEAL MAKER" ||
				document.title === "DEAL REVIEW" ||
				document.title === "PRE-DELIVERY"
			) && renderAllRows
				? false
				: true,
		},
		{
			headerName: "Entry Date",
			field: "date_entered_in_current_queue",
			align: 'center',
			flex: 0.85,
			filtering: true,
			type: 'date',
			dateSetting: { locale: "en-US" },
			renderCell: (rowData) => {
				if (!rowData?.row?.date_entered_in_current_queue) {
					return "-";
				}
				return new Date(rowData?.row?.date_entered_in_current_queue).toLocaleDateString("en-US");
			},
			hide: (document.title === "APP REVIEW" ||
				document.title === "ASSET REVIEW" ||
				document.title === "PRE-CREDIT REVIEW" ||
				document.title === "CREDIT REVIEW" ||
				document.title === "CREDIT ADJUDICATION"
			) ? true : !renderAllRows,
		},
		{
			headerName: "Approval Expiration Date",
			field: "credit_app_expiration_date",
			align: 'center',
			flex: 0.85,
			filtering: true,
			type: 'date',
			dateSetting: { locale: "en-US" },
			renderCell: (rowData) => {
				if (!rowData?.row?.credit_app_expiration_date) {
					return "-";
				}
				return new Date(rowData?.row?.credit_app_expiration_date).toLocaleDateString("en-US");
			},
			hide: (document.title === "DEAL REVIEW" ||
				document.title === "DOCUMENT DATA REVIEW" ||
				document.title === "DOCUMENTS SENT" ||
				document.title === "DOCUMENT REVIEW" ||
				document.title === "PRE-DELIVERY"
			) && renderAllRows
				? false
				: true,
		}, {
			headerName: "Runtime",
			field: "runtime",
			headerAlign: 'center',
			filtering: true,
			align: "left",
			hide: !renderAllRows ||
				!(document.title.includes("APP")
					|| document.title.includes("CREDIT")
					|| document.title.includes("ASSET"))
			,
			sortComparator: (v1, v2) => v1.localeCompare(v2, 'en', { numeric: true })
		},
		{
			headerName: "Action",
			align: "center",
			field: "application_state",
			flex: 0.25,
			minWidth: 50,
			headerAlign: 'center',
			valueGetter: params => {
				const isUser =
					params?.row?.locked_by_email?.toLowerCase() ===
						window?.authProvider?.account?.userName?.toLowerCase()
						? true
						: false;

				if (params?.row?.is_locked && !isUser) {
					return "Locked";
				} else if (!params?.row?.is_locked && !isUser) {
					return "Open";
				} else if (params?.row?.is_locked && isUser) {
					return "Me";
				}
			},
			filtering: true,
			renderCell: (rowData) => {
				const appData = { ...rowData?.row };
				if (appData?.portalSource) {
					delete appData?.portalSource;
				}
				const isUser =
					rowData?.row?.locked_by_email?.toLowerCase() ===
						window?.authProvider?.account?.userName?.toLowerCase()
						? true
						: false;

				return (
					<Box style={renderCustomCell(rowData?.row)}>
						<ActionButton
							onAppOpen={onAppOpen}
							app={appData}
							isUser={isUser}
							isAdminConsole={isAdminConsole}
							setTransferOpen={(bool) => handleTransferOpen(bool, appData)}
							setTransferOptions={setTransferOptions}
							setMoveOpen={(bool) => handleMoveOpen(bool, appData)}
						/>
					</Box>
				);
			},
		},
	];

	// Defaults derived live from each column's hide: (so dynamic hide: !renderAllRows
	// / document.title rules still drive the default view); user overrides layer on top.
	const defaultVisibility = primaryColumn.reduce((acc, col) => {
		acc[col.field] = !col.hide;
		return acc;
	}, {});
	const columnVisibilityModel = { ...defaultVisibility, ...columnVisOverrides };
	const handleColumnVisibilityChange = (nextModel) => {
		const overrides = Object.fromEntries(
			Object.entries(nextModel).filter(
				([field, visible]) => visible !== defaultVisibility[field]
			)
		);
		setColumnVisOverrides(overrides);
		localStorage.setItem("queueColumnVisibility", JSON.stringify(overrides));
	};

	return (
		<Box style={{ display: 'flex', height: pageHeight - 60, background: 'white' }}>
			<Box
				style={{ flexGrow: 1 }}
			//removingg color formatting
			// sx={{
			// 	"& .super-app-theme--header": {
			// 		backgroundColor: "#FF9AA2",
			// 	},
			// 	'& .super-app-theme--secondary': {
			// 		backgroundColor: '#FFDFD3',
			// 	},
			// 	'& .super-app-theme--trinaray': {
			// 		backgroundColor: '#efefef',
			// 	},
			// 	'& .super-app-theme--default': {
			// 		backgroundColor: '#fcfcfc',
			// 	},
			// }}
			>
				<DataGrid
					pageSize={pageHeight < 1000 ? 20 : 25}
					rows={materialData}
					rowsPerPageOptions={[]}
					rowHeight={35}
					columns={primaryColumn}
					columnVisibilityModel={columnVisibilityModel}
					onColumnVisibilityModelChange={handleColumnVisibilityChange}
					sortModel={sortModel}
					onSortModelChange={handleSortModel}
					// getRowClassName={(param) => {
					// 	let row = param?.row;
					// 	let backColor = "";

					// 	if (row?.Is_Premium) {
					// 		backColor = `super-app-theme--header`;
					// 	} else if (row?.is_discounted) {
					// 		backColor = `super-app-theme--secondary`;
					// 	} else if (param?.indexRelativeToCurrentPage % 2 === 0) {
					// 		backColor = `super-app-theme--trinaray`;
					// 	} else {
					// 		backColor = `super-app-theme--default`;
					// 	}
					// 	return backColor;
					// }}
					hideFooterSelectedRowCount
				/>
				<TransferDialog
					app={curAppData}
					open={transferOpen}
					setOpen={(bool) => handleTransferOpen(bool, {})}
					title="Transfer Application?"
					content="Transfer the application to the following person:"
					transferPerson={transferPerson}
					setTransferPerson={setTransferPerson}
					transferOptions={transferOptions}
					setTransferOptions={setTransferOptions}
					transferDeal={() => transferDeal(curAppData)}
				/>
				<MoveDialog
					moveNote={moveNote}
					setMoveNote={setMoveNote}
					moveStatus={moveStatus}
					setMoveStatus={setMoveStatus}
					open={moveDMOpen}
					setOpen={(bool) => handleMoveOpen(bool, {})}
					title="Move Application?"
					content="Move application to the Deal Maker"
					moveAppToQueue={() => moveAppToQueue(curAppData)}
				/>
			</Box>
		</Box>
	);
};

export default AppTable;
